module.exports = __webpack_public_path__ + "static/media/lob-member-1.1dd81b66.jpg";